import React, { useState, useEffect, type FormEvent } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../components/AuthContext';

const LoginPage: React.FC = () => {
  const { login, loading } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [timeoutMessage, setTimeoutMessage] = useState<boolean>(false);

  // Vérifier si l'utilisateur a été déconnecté automatiquement
  useEffect(() => {
    const reason = searchParams.get('reason');
    if (reason === 'timeout') {
      setTimeoutMessage(true);
      // Supprimer le paramètre de l'URL après 5 secondes
      setTimeout(() => {
        setTimeoutMessage(false);
      }, 10000);
    }
  }, [searchParams]);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');

    console.log('📝 Form submit - Email:', email, 'Password:', password ? '***' : 'empty');

    try {
      await login({ email: email.toLowerCase().trim(), password });
      navigate('/dashboard', { replace: true });
    } catch (err: any) {
      console.error('❌ Login failed:', err);
      console.error('❌ Error details:', {
        response: err?.response,
        data: err?.response?.data,
        status: err?.response?.status,
      });
      
      const errorMessage =
        err?.response?.data?.non_field_errors?.[0] ||
        err?.response?.data?.detail ||
        'Identifiants invalides. Veuillez réessayer.';
      setError(errorMessage);
    }
  };
  
  return (
    <div className="flex items-center justify-center min-h-screen bg-base-200">
      <form onSubmit={handleSubmit} className="card w-full max-w-sm shadow-2xl bg-base-100 p-6">
        
        {/* Espace pour le Logo */}
        <div className="flex justify-center mb-6">
          {/* Remplacez ce SVG par votre image de logo (ex: <img src="/path/to/your/logo.png" alt="Logo" className="h-16 w-auto"/>) */}
          <img src="/fidexLogo.png" alt="Logo" className="h-25 w-auto"/>
        </div>

        {/* Titre "Connexion" */}
        <h2 className="text-3xl font-bold text-center mb-6">
          Connexion
        </h2>

        {/* Message de déconnexion automatique */}
        {timeoutMessage && (
          <div role="alert" className="alert alert-warning mb-4 text-sm">
            <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            <span>Vous avez été déconnecté pour inactivité pour des raisons de sécurité.</span>
          </div>
        )}

        {/* Champs de formulaire */}
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Adresse email"
          className="input input-bordered w-full mb-4"
          aria-label="Adresse email"
          autoComplete="email"
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Mot de passe"
          className="input input-bordered w-full mb-4"
          aria-label="Mot de passe"
          autoComplete="current-password"
        />
        
        {/* Message d'erreur */}
        {error && (
            <div role="alert" className="alert alert-error mb-4 text-sm">
              <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
              <span>{error}</span>
            </div>
          )}

        {/* Bouton de soumission */}
        <button type="submit" className={`btn btn-warning w-full mt-2 ${loading ? 'loading' : ''}`} disabled={loading}>
          {loading ? 'Connexion en cours...' : 'Se connecter'}
        </button>

        {/* Bouton d'inscription masqué pour sécurité */}
        {/* <div className="text-center mt-4">
          <span className="text-sm">Pas encore de compte ? </span>
          <Link to="/register" className="link link-primary text-sm font-semibold">
            S'inscrire
          </Link>
        </div> */}
      </form>
    </div>
  );
};

export default LoginPage;